function handleValidation(current_step,type,title) {
  var flag = false;
  var checkboxes = $(`.tv-step-${current_step}`).find(`:${type}`);
  
  var appendData = []; 
  var obj = {}; 
  var key = `step_${current_step}`;
  checkboxes.each(function() {
    var checkbox = $(this).prop('checked');
    if(checkbox === true){
      flag = true;
    }
  });

  if(flag === true){
    genrateHtml(appendData);
    console.log('Append Data', appendData);
  }
  return flag;
}


function genrateHtml(params) {
  var main_object = []; 
  $('#televisionInstallations .tv-step').each(function(index, element) {
    var title = $(this).find('.step_heading').text();
    var current_step = $(this).attr('data-step');
    var element_data = [];
    var flag = false;
    
    if(current_step == '1' || current_step == '5' || current_step == '6'){  // Radio Button
         var element_type = $(this).find(':radio');
    }

    if(current_step == '2' || current_step == '3' ||  current_step == '7' || current_step == '8' || current_step == '9'){  // Checkbox Button
        var element_type = $(this).find(':checkbox');
    }

    if(current_step != '4' && current_step != '10'){  
        element_type.each(function() {
          var checkbox = $(this).prop('checked');
            if(checkbox === true){
               var price = $(this).attr('data-price');
               //$(this).parent().find(':hidden').val(`$${price}`);
               var qty = '1';
               var label = $(this).val();
               element_data.push({title:title, label:label, price: price, qty: 1 });
               flag = true;
            }   
       });
    }

    if(current_step == '4'){  // Simple Input
        var device_val = $('#televisionInstallations').find('#divice_val').val();
        if(device_val != ''){
         var price = $('#televisionInstallations').find('#divice_val').attr('data-price');
          var qty = device_val;
           element_data.push({title:title, label:'Device', price: price, qty: qty });
           flag = true;
        }
    }
    
    if(flag === true){
       main_object.push(element_data);
    } 
    
  });
  
  var html_source = '';
   console.log('All Data', main_object);
   var grand_total = 0;
   var sum = 0;
   $.each(main_object, function(index, subArray) {
     html_source +='<tr><th colspan="3" class="step-heading" data-step="">'+subArray[0].title+'</th></tr>';
      for (var i = 0; i < subArray.length; i++) {
         grand_total = grand_total + parseFloat(subArray[i].price);
        
         html_source +='<tr>';
            html_source +='<td class="step-item-label">'+subArray[i].label+'</td>';	
            html_source +='<td class="step-item-quantity">'+subArray[i].qty+'</td>';	
            html_source +='<td class="step-item-price">$'+subArray[i].price+'</td>';	
        html_source +='</tr>';
      }
  });

  html_source +='<tr>';
      html_source +='<td class="step-item-label">Total</td>';	
      html_source +='<td class="step-item-quantity"></td>';	
      html_source +='<td class="step-item-price">$'+grand_total+'</td>';	
  html_source +='</tr>';
  
  $('#televisionInstallations').find('#grandTotal').val('$'+grand_total);
  $('#televisionInstallations').find('#stepsSummary').find('tbody').empty();
  $('#televisionInstallations').find('#stepsSummary').find('tbody').append(html_source);
}

 document.addEventListener('DOMContentLoaded', function() {
  // document.getElementById('televisionInstallations_frm').addEventListener('submit', function(event) {
  // document.getElementById('televisionInstallations_frm').addEventListener('submit', function(event) {
      
    // var name = document.getElementById('frm_name').value;
    // var email = document.getElementById('frm_email').value;
    // var mobile = document.getElementById('frm_phone').value;

     // if(!name) {
     //      alert('Please fill out all required fields. name');
     //      event.preventDefault();
     //      return false; 
     //    }else if(!email){
     //       event.preventDefault();
     //      alert('Please fill out all required fields. email');
     //    }else if(!mobile){
     //       event.preventDefault();
     //      alert('Please fill out all required fields. mobile');
     //  }

 // });

  
  var urlParams = new URLSearchParams(window.location.search);
  var successParam = urlParams.get('contact_posted');
  console.log('URL', successParam);
  if (successParam === 'true') {
    document.getElementById('television-installations-success').style.display = 'block';
    document.getElementById('televisionInstallations').style.display = 'none';
     document.getElementById('progressSection').style.display = 'none';
      setTimeout(() => {
         window.location.href = '/';
      }, "4000");
  } else {
    // document.getElementById('television-installations-success').style.display = 'none';
    // document.getElementById('televisionInstallations').style.display = 'block';
    //  document.getElementById('progressSection').style.display = 'block';
  }
});

$(document).ready(function(){

  // setTimeout(function(){
  //   $(".mega-menu__nav > li").each(function(){

  
  //   var attr1 = $('.mega-menu__nav > li > a').attr('aria-current');
   
  //     if (typeof attr1 !== 'undefined' && attr1 !== false) {
  //         alert('yes');
  //       $(this).addClass('testts');
  //     }

  //     });
  // }, 6000);

  

  var currentURL = window.location.href;
  if (currentURL.indexOf('outdoor-living') !== -1) {
    $('.header__icon-list').find('.contents li:nth-child(3) details').attr('open', '');
  } 
  var currentURL = window.location.href;
  if (currentURL.indexOf('home-theaters') !== -1) {
    $('.header__icon-list').find('.contents li:nth-child(3) details').attr('open', '');
  } 




  $(document).on('change','#handleMessageBox',function(event){
        $('#messageBox').toggleClass('active');
  });

  $(document).on('click','.handlePagination',function(event){
      event.preventDefault();
      let current_step = $(this).attr('current-step');
      let next_step = $(this).attr('next-step');
      $('#televisionInstallations').find('.tv-step-error').hide();
      var title = $('#televisionInstallations').find(`.tv-step-${current_step}`).find('.step_heading').text();
      if(current_step == '3'){
        var validation_status = handleValidation(current_step,'checkbox',title);
        if(validation_status === false){
          $('#televisionInstallations').find('.tv-step-error').slideToggle('slow');
           return false; 
        }
      }else if(current_step == '1'
              || current_step == '5'
              || current_step == '6'
              ){
         var validation_status = handleValidation(current_step,'radio',title);
          if(validation_status === false){
            $('#televisionInstallations').find('.tv-step-error').slideToggle('slow');
             return false; 
          }
      }else if(current_step == '8'){
        
        genrateHtml(title);
      }
    
      $('#televisionInstallations').find(`.tv-step-${current_step}`).removeClass('active');
      $('#televisionInstallations').find(`.tv-step-${next_step}`).addClass('active');
      $('#pregressBar').find('#progressStep span').text(next_step);
      $('#pregressBar').width(next_step*11+'%');


     $('html, body').animate({
        scrollTop: $('#progressSection').offset().top
      }, 1000);
    
  });

  $(document).on('click','.handlePreviousStep',function(event){
      event.preventDefault();
       let back_step = $(this).attr('back-step');
       let current_step = $(this).attr('current-step');
     
       $('#televisionInstallations').find(`.tv-step-${current_step}`).removeClass('active');
       $('#televisionInstallations').find(`.tv-step-${back_step}`).addClass('active');
       $('#pregressBar').find('#progressStep span').text(back_step);
       $('#pregressBar').width(back_step*11+'%');
     
  });

  $('.step-item-image').click(function(){
    $(this).toggleClass('active');     
  });   

  // Testimonials
  var swiper = new Swiper(".testimonial-list",{
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,    
    autoHeight: true,
    pagination:{
      el: ".swiper-pagination",
      clickable: true,
      type: "fraction",
    },
    navigation:{
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {      
      770:{
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1366:{
        slidesPerView: 3,
      },
      1600:{
        slidesPerView: 4,        
      }
    } 
    
  });  
  
});

